"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.NumberConstant = void 0;
exports.NumberConstant = {
    GRAPHQL_MAX_INT: 2 ** 31 - 1,
};
const round = (value, decimals = 2) => {
    if (decimals === 0) {
        return Math.round(value);
    }
    const multiplier = 10 ** decimals;
    return Math.round(value * multiplier) / multiplier;
};
exports.round = round;
